// Import your app module
import App from './App.js';

// Global variables
var app = null;

// Hide notification function
window.hideNotification = function (el) {
    el.style.display = "none";
};

// Hide debug function
window.hideDebug = function() {
    document.getElementById('debug').style.display = 'none';
};

// Start function
function start() {
    app = new App(window);
    // Make app globally accessible for HTML onclick handlers
    window.app = app;
}

// DOM Content Loaded event listener
window.addEventListener("DOMContentLoaded", function () {
    if (typeof cordova !== "undefined") {
        document.addEventListener("deviceready", function () {
            start();
        }, false);
    } else {
        start();
    }
}, false);

// WebGL context lost handler
window.addEventListener("webglcontextlost", function (event) {
    console.warn("windows.addEventListener - webglcontextlost. Reloading game", event);
    if (typeof app !== "undefined" && app && app.analyticsJI) {
        app.analyticsJI.trackError("webglcontextlost");
    }
});

// Global error handler
window.onerror = function (message, source, lineno, colno, error) {
    if (typeof app !== "undefined" && app && app.analyticsJI) {
        app.analyticsJI.trackError(message, source, lineno, colno, error);
    }
}

// Debug key detection (Ctrl+Alt+D)
var _debugKeys = [];
window.addEventListener("keydown", function (event) {
    if (event.ctrlKey && event.altKey && event.key === "d") {  // case sensitive
        if (typeof app !== "undefined") app.showDebug();
    }
});

// Service Worker - Only for web PWA, NOT for native Capacitor app
if ('serviceWorker' in navigator && !window.Capacitor) {
    // Register service worker for PWA
    navigator.serviceWorker.register('/service-worker.js')
        .then(registration => console.log('Service Worker registered for PWA'))
        .catch(err => console.log('Service Worker registration failed:', err));
} else if ('serviceWorker' in navigator && window.Capacitor) {
    // Unregister any existing service workers in native app
    navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
            registration.unregister();
            console.log('Service Worker unregistered in native app');
        });
    });
}